import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

export class PendingCivilianContact
{
	public constructor(public id: string, public type: string, public email: string, public jurisdictionId: string)
	{

	}
}

@Injectable()
export class SharedPendingCivilianContactRepository
{
	private requestMapping: string = "pendingCivilianContacts";
	private http: HttpClient;

	public constructor(http: HttpClient)
	{
		this.http = http;
	}

	public createPendingCivilianContact(email: string): Observable<PendingCivilianContact>
	{
		return this.http.post<PendingCivilianContact>(this.requestMapping, {email: email});
	}
}
